import {EventEmitter, Injectable} from '@angular/core';
import {SearchRequestModel} from '../shared/dto/search-request.model';
import {MonthWiseCountModel} from '../shared/dto/month-wise-count.model';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SearchRequestDetailModel} from '../shared/dto/search-request-detail.model';
import {ChangeStageFlowModel} from '../shared/dto/changeStageFlow.model';
import {AppConfig} from '../shared/common/app.config';

/*
    @Author - Sajith henarath - sajith_h@epiclanka.net
*/

@Injectable({
  providedIn: 'root'
})
export class StageChangeService {
  requestSearchDetailsChange = new EventEmitter<SearchRequestModel[]>();
  requestCountSearchDetailsChange = new EventEmitter<MonthWiseCountModel[]>();

  private requestSearchDetailsItem: SearchRequestModel[] = [];
  private requestCountSearchDetailsItem: MonthWiseCountModel[] = [];

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(private httpClient: HttpClient, private appConfig: AppConfig) { }

  getAllEligibleRequests() {
    return this.httpClient.get(this.BASE_URL + 'stage-change/all');
  }

  getNextEligibleWorkFlow(currentFlowCode: string) {
    return this.httpClient.get(this.BASE_URL + 'stage-change/nextflow/' + currentFlowCode, {headers: this.headers});
  }

  searchRequestDetails(searchRequestDTO: SearchRequestDetailModel) {
    return this.httpClient.post(this.BASE_URL + 'stage-change/search', searchRequestDTO, {headers: this.headers});
  }

  updateWorkFlowofApplicant(dto: ChangeStageFlowModel, reqId: string) {
    return this.httpClient.post(this.BASE_URL + 'stage-change/update/' + reqId, dto, {responseType: 'text'});
  }

  clearRequestCountSearchDetails() {
    this.requestCountSearchDetailsItem = [];
    this.requestCountSearchDetailsChange.emit(this.requestCountSearchDetailsItem);
  }

  setRequestSearchDetails(requestSearchDetails: SearchRequestModel[]) {
    this.requestSearchDetailsItem = requestSearchDetails;
    this.requestSearchDetailsChange.emit(this.requestSearchDetailsItem);
  }

  clearRequestSearchDetails() {
    this.requestSearchDetailsItem = [];
    this.requestSearchDetailsChange.emit(this.requestSearchDetailsItem);
  }

}










